import { useState, useEffect, useContext, useCallback } from "react";
import { Button, Backdrop, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { API, PAGE_SIZE, CSV_RAC_JA, MSG } from "./constantsFront";
import * as React from 'react';
import _ from 'lodash';
import { MsgContext } from "../../App";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import { CSVLink } from "react-csv";
import { useDropzone } from "react-dropzone";
import CSVReader from 'react-csv-reader'
import moment from "moment";
import { useRef } from "react";

/**
 * 和名頭文字
 * @returns 
 */

const G0208RacJa = () => {
  const [pageSize, setPageSize] = useState(PAGE_SIZE);// リストページサイズ
  const { msg, setMsg } = useContext(MsgContext); // エラーメッセージ

  const [selectedFile, setSelectedFile] = useState(); // 選択したファイル
  const [fileData, setFileData] = useState(); // 選択したファイルデータ
  const [csvErrorMsg, setCsvErrorMsg] = useState([]); // CSVアップロードエラーメッセージ

  const [screenList, setScreenList] = useState([]); // 画面表示一覧

  const [isLoading, setIsLoading] = useState(false);  // Loading

  const navigate = useNavigate();

  let body = { authKey: API.API_KEY };

  // CSVヘッダ
  const csvHeader = [
    { label: "和名頭文字", key: "ja_initials" },
  ];

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    displayData();

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  /**
   * 一覧表示データを取得しScreenListにセットする
   */
  function displayData() {
    // Loading
    setIsLoading(true);
    body = { authKey: API.API_KEY };
    axios.post("/m_rac_ja_initials/select/auth", body).then(res => {
      // 取得チェック
      if (res.status != 200) {
        return;
      }

      let dataList = res.data.dataList.map(row =>
      ({
        ...row,
        // acquisition_date: moment(row.acquisition_date).format("YYYY/MM/DD")
      }));
      setScreenList(dataList);

    }).catch(error => {
      console.log('error:', error);
      setMsg(MSG.EXCEPTION);
    }).finally(() => {
      // Loading
      setIsLoading(false);
    });
  }

  // 画面ヘッダ項目
  const columns = [
    { field: 'ja_initials', headerName: '和名頭文字', width: 200 },
  ];

  // CSVファイルを選択時trueを設定
  const changeHandlerCsv = (event) => {
    setSelectedFile(event.target.files[0]);
    event.target.value = '';
  };

  // ファイル選択ボタン
  const onDrop = useCallback((acceptedFiles) => {
    setSelectedFile(acceptedFiles[0]);
  }, []);
  const { open, acceptedFiles } = useDropzone({
    accept: {
      'text/csv': [],
    },
    multiple: false,
    onDrop,
    noClick: true
  });

  // CSVアップロードボタン
  async function handleFiles() {
    try {
      // Loading
      setIsLoading(true);
      // 再レンダリング用スリープ  
      await new Promise(r => setTimeout(r, 100));

      setFileData();
      setSelectedFile();
      setCsvErrorMsg([]);
      if (!selectedFile) {
        return setMsg("ファイルを選択してください");
      }

      let csletr = [];
      // 重複チェック用
      let uniqueList = [];


      // 1行ごとに処理
      for (let i in fileData) {
        let cells = fileData[i];
        //現在の行数
        let row = Number(i) + 1;

        // 必須チェックエラーカウント
        let csvError = 0;

        //最終行で改行のみのデータの場合読み飛ばす
        if (i == fileData.length - 1 && fileData[i] == "") {
          continue;
        }
        if (cells.length != 1) {
          setMsg("CSVの項目数が違うため取り込みを中止しました。");
          return;
        }

        csletr.push(cells);

        // 必須チェック開始
        if (csletr[i][CSV_RAC_JA.JA_INITIALS] == '') {
          csvError++;
          csvErrorMsg.push(row + "行目 : 和名頭文字は必須です。");
        }

        //同じデータが存在する場合
        let unique =
          "和名頭文字" + csletr[i][CSV_RAC_JA.JA_INITIALS];
        // + "品目" + csletr[i][CSV_RAC_JA.PRODUCT_CODE]
        // + "梱包方法" + csletr[i][CSV_RAC_JA.PACKING]
        // + "有効日" + csletr[i][CSV_RAC_JA.ENABLE_DATE];
        if (uniqueList.indexOf(unique) != -1) {
          csvError++;
          csvErrorMsg.push((uniqueList.indexOf(unique) + 1) + "行目と同じデータが" + row + "行目に存在します。");
        }
        uniqueList.push(unique);

        if (csvError > 0) {
          setMsg(csvErrorMsg.join('<br />'));
          return;
        }
        // 必須チェック終了
      }

      console.log("CSVのチェックが終わりました。");

      let arrStr = JSON.stringify(csletr);
      body.arrStr = arrStr


      const res = await axios.post("/m_rac_ja_initials/upload/auth", body);
      // 植物検疫テーブル
      if (res.status === 200) {
        displayData();
        alert("アップロードに成功しました。");
      }
    } catch (err) {
      setMsg("登録に失敗しました。");
      return;
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <div class="mainLinkMenu"></div>
      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">
            <div class="selectSearchArea">

              <Container maxWidth="lg" >
                {/* Loading */}
                <Backdrop open={isLoading}
                  sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                  <CircularProgress />
                </Backdrop>

                <Stack spacing={2}>
                  <h1>和名頭文字</h1>

                  <Stack spacing={2} direction="row">
                    <Button href="./G0201Rac"
                      style={{
                        width: "200px"
                        , color: "white"
                        , textDecoration: "none"
                      }}>
                      戻る
                    </Button>

                    <CSVLink style={{ color: "white", textDecoration: "none" }}
                      filename={"和名頭文字.csv"} headers={csvHeader} data={screenList}>
                      <Button
                        style={{ width: "200px" }}>CSVダウンロード
                      </Button>
                    </CSVLink>
                  </Stack>

                  <Stack spacing={2} direction="row">

                    <Button style={{ width: "200px" }} letiant="contained" component="label" onChange={changeHandlerCsv}>
                      CSVファイルを選択
                      <CSVReader
                        inputStyle={{ display: "none" }}
                        onFileLoaded={(data, fileInfo, originalFile) => setFileData(data)}
                      />
                    </Button>

                    {selectedFile != null ? (
                      <>
                        <div>
                          <p>ファイル名: {selectedFile.name}</p>
                        </div>
                        <Button
                          style={{ width: "200px" }}
                          onClick={handleFiles}
                        >
                          登録実行
                        </Button>
                      </>
                    ) : (
                      <div><p>CSVファイルが選択されていません</p></div>
                    )}
                  </Stack>

                  <div style={{ width: '100%' }}>
                    <DataGrid
                      className='DataGrid'
                      columns={columns} // ヘッダ項目
                      rows={screenList} // レコード
                      getRowId={(row) => row.ja_initials}  // 一意ID項目
                      autoHeight
                      disableSelectionOnClick
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                      pagination
                      localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                    />
                  </div>

                </Stack>
              </Container>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default G0208RacJa;